module.exports = __webpack_public_path__ + "img/russia.562474ef.svg";